import SearchIcon from "@mui/icons-material/Search";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { auth } from "../config/firebase";
import {
  addUserIdToBasket,
  clearBasket,
  selectBasket,
  selectBasketUserId,
} from "../features/basketSlice";
import { selectUser } from "../features/userSlice";
import "./Header.css";

function Header() {
  const basket = useSelector(selectBasket);
  const basketId = useSelector(selectBasketUserId);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const authHandler = () => {
    if (user) {
      auth.signOut();
    }
  };

  useEffect(() => {
    if (user) {
      if (user.uid !== basketId) {
        console.log(user.uid);
        console.log(basketId);
        dispatch(clearBasket());
        dispatch(
          addUserIdToBasket({
            userId: user.uid,
          })
        );
      }
    }
  }, []);
  return (
    <div className="header">
      <Link to="/">
        <img
          className="header__logo"
          src="https://pngimg.com/uploads/amazon/amazon_PNG25.png"
          alt=""
        />
      </Link>
      <div className="header__search">
        <input className="header__searchInput" type="text" />
        <SearchIcon className="header__searchIcon" />
      </div>

      <div className="header__nav">
        <Link to={!user && "/login"}>
          <div onClick={authHandler} className="header__option">
            <span className="header__optionLineOne">
              Hello {user ? "Hachem" : "Guest"}
            </span>
            <span className="header__optionLineTwo">
              {user ? "Sign Out" : "Sign In"}
            </span>
          </div>
        </Link>
        <Link to="/orders">
          <div className="header__option">
            <span className="header__optionLineOne">Returns</span>
            <span className="header__optionLineTwo">& Orders</span>
          </div>
        </Link>
        <div className="header__option">
          <span className="header__optionLineOne">Your</span>
          <span className="header__optionLineTwo">Prime</span>
        </div>
        <Link to="/checkout">
          <div className="header__optionBasket">
            <ShoppingBasketIcon />
            <div className="header__optionLineTwo header__basketCount">
              {basket?.length}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
export default Header;
